import { resourcesService } from 'ziphy-web-shared/basic/api';
import { isAbsoluteEmpty, isUrl } from 'ziphy-web-shared/basic/helpers';
import { AllergyExtractor, AllergyModal, ConditionExtractor, ConditionModal, ImmunizationExtractor, ImmunizationModal, MedicalSystemToUrlSystem, MedicationRequestExtractor, MedicationRequestModal, MedicationStatementExtractor, MedicationStatementModal, ProcedureExtractor, ProcedureSurgicalHistoryModal, TaskAppointmentModal, TaskExtractor, TaskOrderImagingExtractor, TaskOrderLabExtractor, TaskOrderModal, TaskReferralModal, TaskReferralSpecialistExtractor, TaskRequestAppointmentExtractor, TaskRequestAppointmentPcpExtractor, } from './';
export function getResourceProperties({ resourceType, element, searchPreference, }) {
    if (resourceType === 'AllergyIntolerance') {
        return {
            silentCreate: false,
            searchLabels: {
                resources: 'Existing Allergies',
                preferredCodes: 'Common Allergies',
                codes: 'Allergies',
            },
            service: resourcesService.allergy,
            ModalComponent: AllergyModal,
            extractor: AllergyExtractor,
        };
    }
    if (resourceType === 'Condition') {
        const result = {
            silentCreate: false,
            searchLabels: {
                resources: 'Existing Conditions',
                preferredCodes: 'Common Conditions',
                codes: 'Conditions',
            },
            service: resourcesService.condition,
            ModalComponent: ConditionModal,
            extractor: ConditionExtractor,
        };
        if ((searchPreference === null || searchPreference === void 0 ? void 0 : searchPreference.preference) === 'chief_complaint_preferred_conditions') {
            result.searchLabels = {
                resources: 'Existing Chief Complaint Conditions',
                preferredCodes: 'Common Chief Complaint Conditions',
                codes: 'Conditions',
            };
        }
        else if ((searchPreference === null || searchPreference === void 0 ? void 0 : searchPreference.preference) === 'wound_care_preferred_conditions') {
            result.searchLabels = {
                resources: 'Existing Conditions',
                preferredCodes: 'Common Wound Conditions',
                codes: 'Conditions',
            };
        }
        else if ((searchPreference === null || searchPreference === void 0 ? void 0 : searchPreference.preference) === 'transition_of_care_preferred_conditions') {
            result.searchLabels = {
                resources: 'Existing TOC Diagnosis',
                preferredCodes: 'Common TOC Diagnosis',
                codes: 'Conditions',
            };
        }
        return result;
    }
    if (resourceType === 'MedicationStatement') {
        return {
            silentCreate: false,
            searchLabels: {
                resources: 'Existing Medications',
                preferredCodes: 'Common Medications',
                codes: 'Medications',
            },
            service: resourcesService.medicationStatement,
            ModalComponent: MedicationStatementModal,
            extractor: MedicationStatementExtractor,
        };
    }
    if (resourceType === 'MedicationRequest') {
        return {
            silentCreate: false,
            searchLabels: {
                resources: 'Existing Prescriptions',
                preferredCodes: 'Common Prescriptions',
                codes: 'Prescriptions',
            },
            service: resourcesService.medicationRequest,
            ModalComponent: MedicationRequestModal,
            extractor: MedicationRequestExtractor,
        };
    }
    if (resourceType === 'Procedure') {
        let result = {
            silentCreate: false,
            searchLabels: {
                resources: 'Existing Procedures',
                preferredCodes: 'Common Procedures',
                codes: 'Procedures',
            },
            service: null,
            ModalComponent: null,
            extractor: ProcedureExtractor,
        };
        if (element === 'procedure.surgical_history') {
            result = Object.assign(Object.assign({}, result), { searchLabels: {
                    resources: 'Existing Surgical History',
                    preferredCodes: 'Common Surgical History',
                    codes: 'Surgical History',
                }, service: resourcesService.procedureSurgicalHistory, ModalComponent: ProcedureSurgicalHistoryModal });
        }
        else if (element === 'procedure.billable') {
            result = Object.assign(Object.assign({}, result), { silentCreate: true, searchLabels: {
                    resources: 'Existing Billable Codes',
                    preferredCodes: 'Common Billable Codes',
                    codes: 'Billable Codes',
                }, service: resourcesService.procedureBillable });
        }
        return result;
    }
    if (resourceType === 'Immunization') {
        return {
            silentCreate: false,
            searchLabels: {
                resources: 'Existing Immunizations',
                preferredCodes: 'Common Immunizations',
                codes: 'Immunizations',
            },
            service: resourcesService.immunization,
            ModalComponent: ImmunizationModal,
            extractor: ImmunizationExtractor,
        };
    }
    if (resourceType === 'ServiceRequest') {
        let result = {
            silentCreate: false,
            searchLabels: {
                resources: 'Existing Tasks',
                preferredCodes: 'Common Tasks',
                codes: 'Tasks',
            },
            service: null,
            ModalComponent: null,
            extractor: TaskExtractor,
        };
        if (element === 'referral.specialist') {
            result = Object.assign(Object.assign({}, result), { searchLabels: {
                    resources: 'Existing Care Referrals',
                    preferredCodes: 'Common Care Referrals',
                    codes: 'Referrals',
                }, service: resourcesService.taskReferralSpecialist, extractor: TaskReferralSpecialistExtractor, ModalComponent: TaskReferralModal });
        }
        else if (element === 'referral.service') {
            result = Object.assign(Object.assign({}, result), { searchLabels: {
                    resources: 'Existing Home Health referrals',
                    preferredCodes: 'Common Home Health referrals',
                    codes: 'Referrals',
                }, service: resourcesService.taskReferralService, extractor: TaskReferralSpecialistExtractor, ModalComponent: TaskReferralModal });
        }
        else if (element === 'request.visit.ziphy') {
            result = Object.assign(Object.assign({}, result), { searchLabels: {
                    resources: 'Existing Followup',
                    preferredCodes: 'Followup',
                    codes: 'Followup',
                }, service: resourcesService.taskRequestAppointment, extractor: TaskRequestAppointmentExtractor, ModalComponent: TaskAppointmentModal });
        }
        else if (element === 'request.visit.pcp') {
            result = Object.assign(Object.assign({}, result), { searchLabels: {
                    resources: 'Existing Followup',
                    preferredCodes: 'Followup',
                    codes: 'Followup',
                }, service: resourcesService.taskRequestAppointmentPcp, extractor: TaskRequestAppointmentPcpExtractor, ModalComponent: TaskAppointmentModal });
        }
        else if (element === 'order.lab') {
            result = Object.assign(Object.assign({}, result), { searchLabels: {
                    resources: 'Existing Orders',
                    preferredCodes: 'Common Orders',
                    codes: 'Orders',
                }, service: resourcesService.taskOrderLab, extractor: TaskOrderLabExtractor, ModalComponent: TaskOrderModal });
        }
        else if (element === 'order.imaging') {
            result = Object.assign(Object.assign({}, result), { searchLabels: {
                    resources: 'Existing Orders',
                    preferredCodes: 'Common Orders',
                    codes: 'Orders',
                }, service: resourcesService.taskOrderImaging, extractor: TaskOrderImagingExtractor, ModalComponent: TaskOrderModal });
        }
        return result;
    }
    throw new Error('Unsupported resource.');
}
export function getFhirRef(resourceType, resourceId) {
    return `${resourceType}/${resourceId}`;
}
export function getResourceId(fhirRef) {
    return fhirRef.split('/')[1];
}
export function normalizeSystem(system) {
    if (isUrl(system)) {
        return system;
    }
    else {
        return MedicalSystemToUrlSystem[system] || system;
    }
}
export function createCodeableConcept(resource) {
    var _a;
    if (!resource)
        return null;
    let result = {};
    if (resource.text) {
        result.text = resource.text;
    }
    if (resource.code) {
        result.coding = [
            {
                system: normalizeSystem(resource.system),
                code: resource.code,
                display: 'display' in resource && resource.display ? resource.display : resource.text,
            },
        ];
    }
    if ('other' in resource) {
        (_a = resource.other) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            const tmp = {
                system: normalizeSystem(item.system),
                code: item.code,
                display: item.display || item.text,
            };
            if (Array.isArray(result.coding)) {
                result.coding.push(tmp);
            }
            else {
                result.coding = [tmp];
            }
        });
    }
    return result;
}
export function getResourceCode(data) {
    let result = null;
    if (isAbsoluteEmpty(data)) {
        return result;
    }
    const text = data.text || '';
    if (Array.isArray(data.coding)) {
        data.coding.forEach((item) => {
            const value = {
                text: text,
                code: item.code,
                display: item.display || text,
                system: item.system,
            };
            if (result === null) {
                result = Object.assign(Object.assign({}, value), { other: [] });
            }
            else {
                result.other.push(value);
            }
        });
    }
    else if (text) {
        result = {
            text: text,
            code: '',
            display: text,
            system: '',
            other: [],
        };
    }
    return result;
}
export function isUnspecifiedCode(data) {
    var _a;
    const obj = getResourceCode(data);
    const display = ((_a = obj === null || obj === void 0 ? void 0 : obj.display) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    return /unspecified|not otherwise specified/.test(display);
}
export function isEnteredInErrorStatus(status) {
    return status === 'entered-in-error' || status === 'entered_in_error';
}
export function isEmptyCode(data) {
    return !(data === null || data === void 0 ? void 0 : data.coding);
}
export function checkIfSearchable(searchPreference) {
    return ((searchPreference === null || searchPreference === void 0 ? void 0 : searchPreference.resources) || (searchPreference === null || searchPreference === void 0 ? void 0 : searchPreference.codes) || Boolean(searchPreference === null || searchPreference === void 0 ? void 0 : searchPreference.preference));
}
